var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLexusShowRoom = function SvgLexusShowRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.542 10.116 4.48 9.769l.061-.24.862.321.138.266ZM14.458 10.116l1.061-.347-.061-.24-.861.321-.139.266ZM6 14.5h8",
    stroke: "#101010",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.165 4.5H6.092c-.498.024-.812.394-.992.61l-.762 1.003c-.317-.064-1.02-.013-1.27.683-.252.695.263 1.17.548 1.327l-.615 1.763L3 15.5h3v-1l2-3-.5-1.5H12M7.835 4.5h6.073c.498.024.795.394.992.61l.762.971c.317-.064 1.02-.012 1.27.683.252.695-.262 1.17-.548 1.328l.615 1.762V15.5H14v-1l-2-3 .5-1.5H7.88",
    stroke: "#101010",
    strokeWidth: 0.8
  })));
};
export default SvgLexusShowRoom;